import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AuthTokenState {
  auth0AccessToken: string | null;
}

const initialState: AuthTokenState = {
  auth0AccessToken: null,
};

export const authTokenSlice = createSlice({
  name: 'authToken',
  initialState,
  reducers: {
    setAuth0AccessToken: (state, action: PayloadAction<string | null>) => {
      state.auth0AccessToken = action.payload;
    },
    clearAuth0AccessToken: (state) => {
      state.auth0AccessToken = null;
    },
  },
});

export const { setAuth0AccessToken, clearAuth0AccessToken } = authTokenSlice.actions;

export default authTokenSlice.reducer;
